module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [(!_vm.userChecking) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 col-sm-10 col-lg-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4 login"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-wrap"
  }, [_c('sync-loader', {
    attrs: {
      "size": "15px",
      "color": "#20a8d8"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('message.login.title')))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center title"
  }, [_vm._v(_vm._s(_vm.$t('message.login.header')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.error.email
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.login.user_placeholder')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.error.password
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('message.login.password_placeholder')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("Error: " + _vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block px-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.login.submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center forgot"
  }, [_c('button', {
    staticClass: "btn btn-link px-0",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.login.forgot_password')))])])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "card card-inverse card-primary py-5 d-md-down-none",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', [_c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary active mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchProfile()
      }
    }
  }, [_vm._v("Register Now!")])])])]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo3_color.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e8c436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/Login.vue
// module id = 989
// module chunks = 1